import { Divider } from "@mui/material";
import Typography from "@mui/material/Typography";
import { Edit, SimpleForm } from "react-admin";
import DisplayDateField from "@/components/DisplayDateField";

import MiqaatFormFields, { transformMiqaatPayload, validateMiqaatForm } from "./MiqaatFormFields";

export default function MiqaatEdit() {
  return (
    <Edit mutationMode="optimistic" transform={transformMiqaatPayload}>
      <SimpleForm
        warnWhenUnsavedChanges
        validate={validateMiqaatForm}
        sx={{ maxWidth: 640 }}
        defaultValues={{ familySelfCheckInEnabled: false }}
      >
        <MiqaatFormFields />
        <Divider sx={{ my: 2 }} />
        <Typography variant="subtitle2" color="text.secondary" gutterBottom>
          RSVP activation (read-only)
        </Typography>
        <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 1 }}>
          Set when the first invite is sent successfully for the current occurrence (PERMANENT
          miqaats re-arm after a new Hijri cycle).
        </Typography>
        <DisplayDateField source="rsvpActivatedAt" label="RSVP activated at" showTime />
      </SimpleForm>
    </Edit>
  );
}
